module.exports = __webpack_public_path__ + "img/userB29.c91e7032.jpg";